module.exports = __webpack_public_path__ + "img/bell-off-01.49aef7ca.svg";